<template>
  <a-modal
    v-model="visible1"
    class="modal"
    width="800px"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel(false)"
  >
  <div slot="title" class="tip-icon"> {{title}} </div>
    <div class="fotersa">
      <!-- 展示内容 -->
      <div class="base-content">
        <span class="info">诊断信息详情</span>
        <!-- 表格 -->
        <a-table
          :columns="columns"
          :rowKey="
            (record, index) => {
              return index;
            }
          "
          :data-source="tableData"
          :pagination="false"
          bordered
          size="small"
          :scroll="{ x: 800, y: 'calc(100vh - 300px)' }"
          class="table"
        >
          <span slot="index" slot-scope="text, record, index">
            {{ index + (pageNum - 1) * pageSize + 1 }}
          </span>
          <span slot="status" slot-scope="text, record">
            {{ record.status | DictionaryFilter("DICT_STATUS") }}
          </span>
          <!-- 操作 -->
          <template slot="operation" slot-scope="text">
            <a-button
              href="javascript:;"
              class="modification"
              @click="configuration(text)"
              >详情</a-button
            >
          </template>
        </a-table>

        <!-- 分页 -->
        <div class="base-pagination">
          <div class="total-view">
            共{{ totalRows }}条数据，第{{ pageNum }}/{{ totalPages }}页
          </div>
          <div class="pagination-buttons">
            <a-pagination
              v-model="pageNum"
              :total="totalRows"
              :defaultPageSize="pageSize"
              show-less-items
              @change="changePage($event)"
            />
          </div>
        </div>
      </div>
      <div class="base-content">
        <span class="info2">病历档案</span>
        <!-- 表格 -->
        <a-table
          :columns="columnsss"
          :rowKey="
            (record, index) => {
              return index;
            }
          "
          :data-source="tableData2"
          :pagination="false"
          bordered
          size="small"
          :scroll="{ x: 800, y: 'calc(100vh - 300px)' }"
          class="table"
        >
          <span slot="index" slot-scope="text, record, index">
            {{ index + (pageNum - 1) * pageSize + 1 }}
          </span>
          <span slot="status" slot-scope="text, record">
            {{ record.status | DictionaryFilter("DICT_STATUS") }}
          </span>
        </a-table>

        <!-- 分页 -->
        <div class="base-pagination">
          <div class="total-view">
            共{{ totalRows2 }}条数据，第{{ pageNum2 }}/{{ totalPages2 }}页
          </div>
          <div class="pagination-buttons">
            <a-pagination
              v-model="pageNum2"
              :total="totalRows2"
              :defaultPageSize="pageSize2"
              show-less-items
              @change="changePage2($event)"
            />
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button type="primary" @click="handleOk" :loading="disabled"
        >确 定</a-button
      >
    </template>
    <!-- 详情 -->
    <patadd
      v-if="visibleee"
      :visible="visibleee"
      :userData="patData"
      :type="type"
      :title="pattitle"
      @close="reflush"
      :textId="pattextId"
    ></patadd>
  </a-modal>
</template>
<script>
import { diagQuery, medQuery, patientId } from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
import moment from "moment";
import patadd from "./patient-details";
moment.locale("zh-cn");
export default {

  name: "patadd",
  props: ["visible", "userData", "type", "textId"],
  data() {
    return {
      //详情1
      visibleee:"",
      patData:[],
      pattitle:"详情",
      pattextId:"",



      idCard: "",
      patName: "",
      phoneNo: "",
      //表格1
      tableData: [],
      //表格2
      tableData2: [],
      Title: "",
      title: "患者详情",
      disabled: false,
      // 表单验证
      rules: {
        comments: [
          {
            max: 100,
            message: "备注长度不能超过100",
          },
        ],
        reviewStatus: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
      },
      form: {
        comments: "",
        reviewStatus: undefined,
      },
      //数列1
      columns: [
        {
          title: "序号",
          align: "center",
          dataIndex: "index",
          width: 33,
          key: "index",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
        {
          title: "诊治阶段",
          dataIndex: "diaStage",
          key: "diaStage",
          align: "center",
          ellipsis: true,
          width: 130,
          scopedSlots: { customRender: "diaStage" },
        },
        {
          title: "诊断说明",
          dataIndex: "diaRemark",
          key: "diaRemark",
          align: "center",
          ellipsis: true,
          width: 120,
          scopedSlots: { customRender: "diaRemark" },
        },
        {
          title: "手术时间",
          dataIndex: "surgeryTime",
          key: "surgeryTime",
          align: "center",
          ellipsis: true,
          width: 80,
          scopedSlots: { customRender: "surgeryTime" },
          customRender: (text, row, index) => {
            let time;
            if (text == null) {
              time = "--";
            } else {
              time = moment(text).format("YYYY-MM-DD ");
            }
            return time;
          },
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          width: 150,
          scopedSlots: {
            customRender: "operation",
          },
        },
      ],
      //数列2
      columnsss: [
        {
          title: "序号",
          align: "center",
          dataIndex: "index",
          width: 50,
          key: "index",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
        {
          title: "主要检查报告",
          dataIndex: "mainReport",
          key: "mainReport",
          align: "center",
          ellipsis: true,
          width: 130,
          scopedSlots: { customRender: "mainReport" },
        },
        {
          title: "病历档案",
          dataIndex: "record",
          key: "record",
          align: "center",
          ellipsis: true,
          width: 130,
          scopedSlots: { customRender: "record" },
        },
        {
          title: "档案类型",
          dataIndex: "recordType",
          key: "recordType",
          align: "center",
          ellipsis: true,
          width: 130,
          scopedSlots: { customRender: "recordType" },
        },
        {
          title: "治疗时间",
          dataIndex: "treatmentTime",
          key: "treatmentTime",
          align: "center",
          ellipsis: true,
          width: 130,
          scopedSlots: { customRender: "treatmentTime" },
          customRender: (text, row, index) => {
            let time;
            if (text == null) {
              time = "--";
            } else {
              time = moment(text).format("YYYY-MM-DD ");
            }
            return time;
          },
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          width: 150,
          scopedSlots: {
            customRender: "operation",
          },
        },
      ],
      pageNum: 1,
      pageSize: 10,
      totalRows: 0,
      totalPages: 0,

      pageNum2: 1,
      pageSize2: 10,
      totalRows2: 0,
      totalPages2: 0,
      dictStatus: [],
      formLayout: "horizontal",
      visible1: "",
      relationMan: [],
    };
  },
  watch: {},
  activated() {
    DictionaryService.getAllNeedDic(["DICT_STATUS"]).then((res) => {
      this.QueryList();
      this.QueryList2();
      this.dictStatus = DictionaryService.getOptions("DICT_STATUS");
      this.relationMan = DictionaryService.getOptions("KINSHIP");
    });
  },
  mounted() {
    this.QueryList();
    this.QueryList2();
    this.getId();
    this.visible1 = this.visible;
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 6, offset: 18 },
          }
        : {};
    },
  },
  methods: {
    // 详情1
    configuration(text) {
      this.id = text.id;
      this.visibleee = true;
      this.type = "add";
      this.title = "详情";
      this.pattextId = text.id
    },
    // 详情1关闭弹窗
    reflush(value) {
      //this.visible = value
      this.visibleee = false;
    },
    getId() {
      patientId({ id: this.textId }).then((res) => {
        this.form = res.content;
      });
    },
    //点确定
    handleOk(e) {},

    handleCancel(val) {
      //关闭弹窗
      this.$emit("close", val);
      //this.$refs['ruleForm'].resetFields()
    },

    //分页
    changePage(event) {
      this.pageNum = event;
      this.QueryList();
    },
    //分页2
    changePage2(event) {
      this.pageNum = event;
      this.QueryList2();
    },
    //列表查询1
    QueryList(sum = 2) {
      this.patId = this.$route.query.id;
      if (sum == 1) this.pageNum = 1;
      let obj = {
        pageParam: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderBy: "",
        },
        content: {
          patId: this.patId,
        },
      };
      diagQuery(obj).then(
        (res) => {
          this.tableData = res.content.rows;
          this.totalRows = res.content.page.totalRows;
          this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        },
        (err) => {}
      );
    },
    //列表查询2
    QueryList2(sum = 2) {
      this.patId = this.$route.query.id;
      if (sum == 1) this.pageNum2 = 1;
      let obj = {
        pageParam: {
          pageNum: this.pageNum2,
          pageSize: this.pageSize2,
          orderBy: "",
        },
        content: {
          patId: this.patId,
        },
      };
      medQuery(obj).then(
        (res) => {
          this.tableData2 = res.content.rows;
          this.totalRows2 = res.content.page.totalRows;
          this.totalPages2 = Math.ceil(this.totalRows / this.pageSize);
        },
        (err) => {}
      );
    },
  },
};
</script>
<style lang="less" scoped="scoped">
.btone {
  background-color: #38accf;
  color: white;
}
.bbbbtttt {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  text-shadow: none;
  box-shadow: none;
}
.base-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/.ant-table-body {
  margin-top: -8px !important;
}
.sp_name {
  display: inline-block;
  font-size: 20px;
  margin: 0 0 20px 10px;
}
.fotersa {
  width: 100%;
  height: 100%;
  .title-name {
    width: 100%;
    height: 46px;
    overflow: hidden;
    .sp_name {
      display: inline-block;
      font-size: 20px;
      margin: 0 0 20px 10px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex label {
    font-size: 16px;
    width: 73px;
  }
  .btone {
    background-color: #38accf;
    color: white;
    margin-right: 20px;
  }
  .bttwo {
    background-color: #f59a23;
    color: white;
  }
  .btthree {
    width: 120px;
    background-color: #f59a23;
    color: white;
    margin-top: 20px;
  }
  /deep/.ant-table-thead {
    background-color: #dcf4ff;
  }

  a {
    margin-left: 10px;
    color: #108ee9;
  }
  a:hover {
    color: #70b9cf;
  }
}
/deep/.ant-form-item {
  margin-bottom: 0;
}
.title-name::before {
  content: "";
  width: 5px;
  height: 20px;
  display: inline-block;
  overflow: hidden;
  background-color: #0b2464;
}
/deep/ .ant-table-body {
  max-height: 487px;
  overflow: auto;
  margin: 0 !important;
}
/deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
}
.name {
  font-size: 14px;
  display: inline-block;
  text-align: center;
  width: 26%;
}
.frame {
  width: 74%;
  display: inline-block;
}

.add-mess {
  width: 100%;
  //height: 400px;
  overflow: auto;
  margin-left: -14px;

  /deep/ .ant-form-item {
    display: flex;
    margin-bottom: 20px !important;
  }
  /deep/ .ant-form-item-label {
    width: 110px;
  }
  /deep/ .ant-form-item-control {
    width: 350px;
  }
}
::v-deep .ant-table-small.ant-table-bordered .ant-table-placeholder {
  display: none;
}

/deep/ .form .ant-input,
.ant-form-item-control,
.ant-form-item-control-wrapper {
  width: 160px;
}
.fw {
  width: 246px;
}
.lianxi {
  margin-left: -4px;
  width: 260px;
}
.oper {
  // flex: 1;
  width: 310px;
}
/deep/ .fl .ant-row .ant-col-6:nth-child(1) {
  width: 74px;
}
/deep/ .fl1 .ant-row .ant-col-6:nth-child(1) {
  width: 69px;
}
/deep/ .fl2 .ant-row .ant-col-6:nth-child(1) {
  width: 69px;
}
/deep/ .ant-input-affix-wrapper {
  width: 160px;
}
/deep/ .ant-col-18 {
  width: 50%;
}
.info {
  display: inline-block;
  font-size: 20px;
  margin-bottom: 10px;
}
.info2 {
  display: inline-block;
  font-size: 20px;
  margin-bottom: 10px;
  margin-top: 20px;
}
.modal {
  height: 500px;
}
</style>